(() => {
  'use strict';

  const initPicker = (field) => {
    if (!field || field.dataset.pdpGrillBrandInit === 'true') return;
    field.dataset.pdpGrillBrandInit = 'true';

    const trigger = field.querySelector('.pdp-grill-brand-trigger');
    const triggerText = field.querySelector('.pdp-grill-brand-trigger-text');
    const menu = field.querySelector('.pdp-grill-brand-menu');
    const search = field.querySelector('.pdp-grill-brand-search');
    const options = [...field.querySelectorAll('.pdp-grill-brand-option')];
    const checkboxes = [...field.querySelectorAll('.pdp-grill-brand-checkbox')];
    const noResult = field.querySelector('.pdp-grill-brand-no-result');
    const otherInput = field.querySelector('.pdp-grill-brand-other');
    const error = field.querySelector('.pdp-grill-brand-error');
    const hiddenValue = field.querySelector('.pdp-grill-brand-value');
    const othersCheckbox = field.querySelector('#pdp-grill-brand-others');
    const othersOption = field.querySelector('.pdp-grill-brand-option--others');

    const getAtcButtons = () => {
      const formId = hiddenValue.getAttribute('form');
      if (formId) {
        const form = document.getElementById(formId);
        if (form) return form.querySelectorAll('[name="add"], .product-form__submit');
      }
      const productInfo = field.closest('product-info') ?? document;
      return productInfo.querySelectorAll('[name="add"], .product-form__submit');
    };

    const getSelectedBrands = () =>
      checkboxes.filter((cb) => cb.checked).map((cb) => cb.value);

    const getFinalValues = () => {
      const selected = getSelectedBrands();
      const otherVal = otherInput.value.trim();
      const finalVals = selected.filter((value) => value !== 'Others');

      if (selected.includes('Others') && otherVal !== '') {
        finalVals.push(otherVal);
      }
      return finalVals;
    };

    const isValid = () => {
      const selected = getSelectedBrands();
      if (!selected.length) return false;
      if (selected.includes('Others') && !otherInput.value.trim()) return false;
      return true;
    };

    const updateAtcState = () => {
      const { display, visibility } = window.getComputedStyle(field);
      if (display === 'none' || visibility === 'hidden') {
        getAtcButtons().forEach((btn) => {
          btn.disabled = false;
          btn.removeAttribute('aria-disabled');
        });
        return;
      }

      const valid = isValid();
      getAtcButtons().forEach((btn) => {
        btn.disabled = !valid;
        if (valid) {
          btn.removeAttribute('aria-disabled');
        } else {
          btn.setAttribute('aria-disabled', 'true');
        }
      });
    };

    const updateCartNote = (values) => {
      if (!values || !values.length) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          note: 'Grill Brand: ' + values.join(', ')
        })
      });
    };

    const sync = () => {
      const selected = getSelectedBrands();
      const otherVal = otherInput.value.trim();

      const displayVals = selected.map((value) =>
        value === 'Others' ? (otherVal || 'Others') : value
      );

      if (displayVals.length) {
        triggerText.textContent = displayVals.join(', ');
        trigger.classList.add('has-selection');
      } else {
        triggerText.textContent = 'Select your brand(s)';
        trigger.classList.remove('has-selection');
      }

      const { display, visibility } = window.getComputedStyle(field);
      const isHidden = display === 'none' || visibility === 'hidden';
      const finalValues = getFinalValues();

      if (isHidden || !finalValues.length) {
        hiddenValue.disabled = true;
        hiddenValue.value = '';
      } else {
        hiddenValue.disabled = false;
        hiddenValue.value = finalValues.join(', ');
        updateCartNote(finalValues);
      }

      if (isValid()) error.hidden = true;

      updateAtcState();
    };

    const filterOptions = (query) => {
      const q = query.trim().toLowerCase();
      let visibleCount = 0;

      options.forEach((option) => {
        const checkbox = option.querySelector('.pdp-grill-brand-checkbox');
        if (checkbox?.value === 'Others') {
          option.hidden = q.length > 0;
          return;
        }
        const text = option.textContent.toLowerCase();
        if (!q || text.includes(q)) {
          option.hidden = false;
          visibleCount++;
        } else {
          option.hidden = true;
        }
      });

      if (q && visibleCount === 0) {
        noResult.hidden = false;
        if (othersOption) othersOption.hidden = false;
      } else {
        noResult.hidden = true;
      }
    };

    const openMenu = () => {
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
      search.value = '';
      filterOptions('');
      setTimeout(() => search.focus(), 50);
    };

    const closeMenu = () => {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    };

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      menu.hidden ? openMenu() : closeMenu();
    });

    menu.addEventListener('click', (e) => e.stopPropagation());

    document.addEventListener('click', (e) => {
      if (!field.contains(e.target)) closeMenu();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !menu.hidden) closeMenu();
    });

    search.addEventListener('input', () => filterOptions(search.value));

    checkboxes.forEach((cb) => {
      cb.addEventListener('change', () => {
        if (othersCheckbox?.checked) {
          otherInput.hidden = false;
        } else {
          otherInput.hidden = true;
          otherInput.value = '';
        }
        sync();
      });
    });

    otherInput.addEventListener('input', sync);

    const formId = hiddenValue.getAttribute('form');
    if (formId) {
      const form = document.getElementById(formId);
      if (form) {
        form.addEventListener(
          'submit',
          (e) => {
            const { display, visibility } = window.getComputedStyle(field);
            if (display === 'none' || visibility === 'hidden') return;

            if (!isValid()) {
              e.preventDefault();
              e.stopPropagation();
              error.hidden = false;
              error.textContent = getSelectedBrands().includes('Others')
                ? 'Please enter your grill brand.'
                : 'Please select at least one grill brand.';
              field.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          },
          true
        );
      }
    }

    sync();
  };

  const initAll = () => {
    document.querySelectorAll('[data-pdp-grill-brand]').forEach(initPicker);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);

  const observer = new MutationObserver(initAll);
  observer.observe(document.body, { childList: true, subtree: true });
})();